import React, { ReactElement } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { ListSubheader } from '@material-ui/core';
import FsFilterArrowIcon from 'ui-elements/icons/FsFilterArrow';
import { useReportAccountContext } from 'contexts/report/ReportAccountContext';
import defaultLocales from 'globals/locales/default';
import { getIconStyle, getListSubHeaderStyle } from './FsAccountPicker.style';
import {
  CustomFormControl,
  CustomTextField,
} from './FsAccountPicker.style-elements';

interface Account {
  id: string;
  name: string;
  currency: string;
}

interface BankProps {
  id: number;
  name: string;
  accounts: Account[];
}

interface FsAccountPickerProps {
  banks: BankProps[];
}

const FsAccountPicker: React.FC<FsAccountPickerProps> = ({ banks }) => {
  const { setActiveAccountId } = useReportAccountContext();
  const iconStyle = getIconStyle();
  const listSubHeaderStyle = getListSubHeaderStyle();
  const [accountId, setAccountId] = React.useState<string>('all');
  const accountLength = banks.reduce(
    (total, item) => total + item.accounts.length,
    0
  );
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>): void => {
    const newAccountId = event.target.value as string;
    setAccountId(newAccountId);
    setActiveAccountId(newAccountId);
  };

  return (
    <CustomFormControl variant="outlined">
      <CustomTextField
        data-test="text-field-select"
        data-banks-length={banks.length}
        data-accounts-length={accountLength}
        select
        defaultValue="all"
        fullWidth
        size="small"
        onChange={handleChange}
        value={accountId}
        variant="outlined"
        label={defaultLocales.account}
        SelectProps={{
          IconComponent: ({ className, props }): ReactElement => (
            <i
              {...props}
              className={`material-icons ${className}`}
              style={iconStyle}
            >
              <FsFilterArrowIcon />
            </i>
          ),
        }}
      >
        <MenuItem value="all">
          <em>All accounts</em>
        </MenuItem>
        {banks.map(({ name: bankName, accounts }) => {
          const accountItems = accounts.map(({ id, name, currency }) => (
            <MenuItem
              data-test="account-picker-option"
              key={id}
              value={id}
            >{`${currency} | ${name}`}</MenuItem>
          ));
          return [
            <ListSubheader style={listSubHeaderStyle}>
              {bankName}
            </ListSubheader>,
            ...accountItems,
          ];
        })}
      </CustomTextField>
    </CustomFormControl>
  );
};

export default FsAccountPicker;
